import { api } from 'api/api';
import { UserResponseViewModel } from 'types/user';
import { GetUsersRequest, UpdateUserProfileRequest, CreateUserProfileRequest, UsersResponse } from './types';
import { parametrizeURL } from 'api/utils';

export const USER_URL = 'User' as const;
export const GET_USERS_URL = `${USER_URL}/GetAllAsync` as const;
export const ADD_USER_URL = `${USER_URL}/AddAsync` as const;
export const UPDATE_USER_URL = `${USER_URL}/UpdateAsync/{userId}` as const;

export const readUserById = (params: { id: string }) => api.get<UserResponseViewModel>(USER_URL, { params });

export const deleteUserById = (data: { id: string }) => api.delete<void>(USER_URL, { data });

export const readUsers = (params: GetUsersRequest) => api.get<UsersResponse>(GET_USERS_URL, { params });

export const createUser = (body: CreateUserProfileRequest) => api.post<UserResponseViewModel>(ADD_USER_URL, body);

export const replaceUser = (body: UpdateUserProfileRequest, userId: string) =>
    api.post<UserResponseViewModel>(parametrizeURL(UPDATE_USER_URL, { userId }), body);
